define(["require", "exports", "jquery", "knockout", "../../utils/urls", "log", "../../utils/tools", "../../models/PhoneNumberProviderModel"], function (require, exports, $, ko, urls_1, log, tools, PhoneNumberProviderModel) {
    "use strict";
    var PhoneNumberProviderActions = /** @class */ (function () {
        function PhoneNumberProviderActions() {
            this.editModel = ko.observable(new PhoneNumberProviderModel());
            this.deleteModel = ko.observable(new PhoneNumberProviderModel());
        }
        PhoneNumberProviderActions.prototype.init = function () {
        };
        PhoneNumberProviderActions.prototype.editPhoneNumberProvider = function (theId, name, webSite) {
            var self = this;
            var title = "Add New Phone Number Provider";
            if ($.isNumeric(theId) && name) {
                title = "Edit ".concat(name, " Details");
            }
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!self.editModel().Name()) {
                        tools.error("Name is required");
                        return;
                    }
                    if (self.editModel().Website()) {
                        var regex = /^[(?:(?:https?|ftp):\/\/)]*(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/i;
                        var valid = regex.test(self.editModel().Website());
                        if (!valid) {
                            tools.error("Website is not a valid URL");
                            return;
                        }
                    }
                    $(event.currentTarget).button("loading");
                    self.savePhoneNumberProvider(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if ($.isNumeric(theId)) {
                        getModelCall = tools.ajaxGet({
                            url: urls_1.urls.phoneNumberProvidersGetById,
                            data: { id: theId },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new PhoneNumberProviderModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new PhoneNumberProviderModel());
                    }
                    $.when(getModelCall).done(function (data) {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'phonenumberprovider-edit-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        PhoneNumberProviderActions.prototype.savePhoneNumberProvider = function (btn, modal) {
            var _this = this;
            var self = this;
            var obj = ko.mapping.toJS(self.editModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/PhoneNumberProviders/SavePhoneNumberProvider",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    if (_this.saveCallback) {
                        _this.saveCallback(result.Data);
                    }
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        PhoneNumberProviderActions.prototype.deleteNumberProviderConfirm = function (theId, name) {
            var self = this;
            self.deleteModel(new PhoneNumberProviderModel());
            self.deleteModel().Id(theId);
            self.deleteModel().Name(name);
            tools.editModal({
                title: "Delete Phone Number Provider - " + name,
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {},
                save: function (event, modal) {
                    $(event.currentTarget).button("loading");
                    self.deleteNumberProvider(event.currentTarget, modal);
                },
                opened: function (modal) {
                    $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'phonenumberprovider-remove-template', data: deleteModel }\"></div>");
                    ko.applyBindings(self, modal);
                }
            });
        };
        PhoneNumberProviderActions.prototype.deleteNumberProvider = function (btn, modal) {
            var self = this;
            var data = {
                id: self.deleteModel().Id()
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/PhoneNumberProviders/DeletePhoneNumberProviderConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Phone number provider deleted successfully");
                    if (self.deleteCallback) {
                        self.deleteCallback();
                    }
                    $(modal).modal("hide");
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        return PhoneNumberProviderActions;
    }());
    return PhoneNumberProviderActions;
});
//# sourceMappingURL=phoneNumberProviderActions.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/phoneNumberProviders/phoneNumberProviderActions.js
// module id = 87
// module chunks = 2